// TSS vite/03 §"Query keys".

export const recipientKeys = {
    all:      ['recipients'],
    list:     (filters) => ['recipients', 'list', filters],
    infinite: (filters, limit) => ['recipients', 'list', 'infinite', filters, limit],
    detail:   (id)      => ['recipients', 'detail', id],
};
